package one.healthium.profile.navigation.update_initial_weight

import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.lifecycle.viewmodel.compose.LocalViewModelStoreOwner
import one.healthium.profile.ui.update_initial_weight.UpdateInitialWeightScreen

@Composable
fun UpdateInitialWeightContent(component: UpdateInitialWeightComponent) {
    CompositionLocalProvider(LocalViewModelStoreOwner provides component) {
        UpdateInitialWeightScreen(component.isTargetWeight, component)
    }
}